import React, { useState, useEffect } from "react";

// libraries
import { Grid, Dropdown, Form, Label, Button } from "semantic-ui-react";
import Joi from "joi";
import PropTypes from "prop-types";
import { isEmpty, map, isEqual, trim, get, reject, filter, includes, omit } from "lodash";

// Components
import Input from "@Components/Input";
import FileManager from "@Components/FileManager";
import NewTable from "@Components/NewTable";
import TextAreaInput from "@Components/TextArea";
import IKModal from "@Components/IkModal";
// Modals
import ConfirmModal from "@Modals/ConfirmModal";
import ButtonstCrud from "./Modals";

// redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";
import { displayNotification } from "@Actions/notifications";

// Utils
// import dataHandler from "@Utils/dataHandler";
import { dropdownFormat } from "@Utils/formats";

// Styles
import styles from "./styles.module.css";

// StaticData
import typesOptions from "./staticData";

const categoryOptions = [
	{ key: "marketing", value: "Marketing", text: "Marketing" },
	{ key: "utility", value: "Utility", text: "Utility" },
	{ key: "authentication", value: "Authentication", text: "Authentication" },
];

const LenguajeOptions = [
	{ key: "spanish", value: "Spanish", text: "Español" },
	{ key: "english", value: "English", text: "Inglés" },
];

const TemplateCrud = ({ modalCrud, tableValue, onClose, dispatch, refresh, company, metaStatus }) => {
	const isApproved = metaStatus === "Aprobada";
	// modal
	const [open, setOpen] = useState(false);
	const [modalOption, setModalOption] = useState("");
	const [openConfirmModal, setOpenConfirmModal] = useState(false);

	// form
	const [initialFormData, setInitialFormData] = useState([]);
	const [isActive, setIsActive] = useState(false);
	const [types, setTypes] = useState("");
	const [images, setImages] = useState([]);
	const [imagesD, setImagesD] = useState([]);
	const [document, setDocument] = useState(null);
	const [modalCrudButton, setModalCrupButton] = useState("");
	const [attachContactName, setAttachContactName] = useState(false);
	const [externalFunction, setExternalFunction] = useState("");
	const [title, setTitle] = useState("");
	const [isPromo, setIsPromo] = useState(false);
	const [channelOption, setChannelOption] = useState(false);
	const [channelId, setChannelId] = useState(null);
	const [header, setHeader] = useState("");
	const [body, setBody] = useState("");
	const [bodyExample, setBodyExample] = useState("");
	const [language, setLanguage] = useState("Spanish");
	const [category, setCategory] = useState("Marketing");
	const [sendToMeta] = useState(false);
	// eslint-disable-next-line no-unused-vars
	const [metaStatusLocal, setMetaStatusLocal] = useState("LOCAL");
	const [sendingToMeta, setSendingToMeta] = useState(false);

	// table
	const [tableValue2, setTableValue2] = useState([]);
	const [openModalAdd, setOpenModalAdd] = useState(false);
	const [filteredItems, setFilteredItems] = useState([]);
	const [buttonsD, setButtonsD] = useState([]);

	// item delete
	const [itemDelete, setItemDelete] = useState({});

	// validation
	const [errors, setErrors] = useState({
		// errors
		fullName: "",
		email: "",
		phone: "",
		password: "",
		channelId: "",
		body: "",
		document: "",
	});

	const validateFileSize = (base64String, maxSizeMB = 5) => {
		if (!base64String) return true;

		const stringLength = base64String.length;
		const sizeInBytes = 4 * Math.ceil(stringLength / 3) * 0.75;
		const sizeInMB = sizeInBytes / (1024 * 1024);

		return sizeInMB <= maxSizeMB;
	};

	// validations
	const defaults = {
		"string.empty": "Este campo es requerido",
		"any.required": "Este campo es requerido",
		"string.min": "Debe tener al menos {#limit} caracteres",
		"string.max": "No debe exceder {#limit} caracteres",
		"number.base": "Debe ser un número válido",
	};

	const schema = Joi.object().keys({
		title: Joi.string()
			.min(4)
			.messages({
				...defaults,
				"string.min": "Nombre debe tener mínimo 6 caracteres",
				"string.empty": "Nombre es un campo requerido",
			}),
		externalFunction: Joi.string()
			.min(4)
			.messages({
				...defaults,
				"string.min": "Plantilla WhatsApp debe tener mínimo 6 caracteres",
				"string.empty": "Plantilla WhatsApp es un campo requerido",
			}),
		channelId: Joi.number()
			.required()
			.messages({
				...defaults,
				"number.base": "Canal es un campo requerido",
			}),
		body: Joi.string()
			.trim()
			.required()
			.messages({
				...defaults,
				"string.empty": "Body es un campo requerido",
				"any.required": "Body es un campo requerido",
			}),
		document: Joi.string()
			.allow("", null)
			.custom((value, helpers) => {
				if (value && types === "Video" && !validateFileSize(value, 5)) {
					return helpers.error("any.invalid");
				}
				return value;
			}, "video-size-validation")
			.messages({
				...defaults,
				"any.invalid": "El video no puede ser mayor a 5MB",
			}),
		header: Joi.string()
			.trim()
			.max(60)
			.allow(null, "")
			.messages({
				...defaults,
				"string.max": "Header no puede exceder 60 caracteres (límite de Meta)",
				"string.base": "Header debe ser texto",
			}),
	});

	// useEffect
	useEffect(() => {
		(async () => {
			setModalOption(modalCrud);

			const channelPromise = dispatch(genericAction({ method: "get", route: "companyChannels" }));

			let templateResponse = null;
			let channelResponse;

			if (modalCrud !== "Add") {
				const templatePromise = dispatch(genericAction({ method: "get", route: `templates/${tableValue.id}` }));
				[templateResponse, channelResponse] = await Promise.all([templatePromise, channelPromise]);
			} else {
				channelResponse = await channelPromise;
			}

			if (modalCrud !== "Add") {
				setTitle(get(templateResponse, "title", ""));
				setAttachContactName(get(templateResponse, "attachContactName", ""));
				setTypes(get(templateResponse, "attachmentType", ""));
				if (get(templateResponse, "attachmentType", "") !== "Image" && get(templateResponse, "attachmentType", "") !== "Text") {
					setDocument(get(templateResponse, "attachmentUri", ""));
				}
				const logo = get(templateResponse, "attachmentUri", []);
				setImages(logo ? [logo] : []);

				setFilteredItems(get(templateResponse, "buttons", ""));
				setExternalFunction(get(templateResponse, "externalFunction", ""));
				setIsActive(get(templateResponse, "isActive", ""));
				setIsPromo(get(templateResponse, "isPromo", ""));
				setInitialFormData(templateResponse);
				const rawChannelId = get(templateResponse, "channelId", null);
				setChannelId(rawChannelId !== null ? Number(rawChannelId) : null);

				setHeader(get(templateResponse, "header", ""));
				setBody(get(templateResponse, "body", ""));
				setBodyExample(get(templateResponse, "bodyExample", ""));
				setLanguage(get(templateResponse, "language") || "Marketing");
				setCategory(get(templateResponse, "category") || "Marketing");
				setMetaStatusLocal(get(templateResponse, "metaStatus") || "LOCAL");
			}
			const whatsappChannels = filter(channelResponse, (ch) => {
				return ch.platform && ch.platform.name && includes(["whatsapp", "whatsapp 360", "personal"], ch.platform.name.toLowerCase());
			});
			const channels = dropdownFormat(whatsappChannels, "label", "id");
			setChannelOption(channels);
		})();
	}, []);

	const modalData = (name, item) => {
		setTableValue2(item);
		setModalCrupButton(name);
		setOpenModalAdd(true);
	};

	const deleteButton = () => {
		setButtonsD([...buttonsD, itemDelete.id]);
		const CurrentItemDelete = reject(filteredItems, (itemD) => {
			return itemDelete.id === itemD.id;
		});
		setFilteredItems(CurrentItemDelete);
		setOpenConfirmModal(false);
	};

	const handleButton = (name, item) => {
		switch (name) {
			case "Watch":
				modalData(name, item);
				break;
			case "Edit":
				modalData(name, item);
				break;
			case "Add":
				modalData(name, []);
				break;
			case "Eraser":
				setOpenConfirmModal(true);
				setItemDelete(item);
				break;
			default:
				break;
		}
	};

	const onSuccess = () => {
		onClose();
		refresh();
	};

	const validateButtons = () => {
		const btns = filteredItems || [];
		if (btns.length === 0) return null;

		const hasQuickReply = btns.some((b) => {
			return b.msgType === "Respuesta Rápida";
		});
		const hasUrl = btns.some((b) => {
			return b.msgType === "URL";
		});
		const hasPhone = btns.some((b) => {
			return b.msgType === "Teléfono";
		});
		const hasCopyCode = btns.some((b) => {
			return b.msgType === "Copiar Código";
		});
		const urlCount = btns.filter((b) => {
			return b.msgType === "URL";
		}).length;
		const phoneCount = btns.filter((b) => {
			return b.msgType === "Teléfono";
		}).length;

		if (category === "Authentication") {
			if (btns.length > 1) return "Authentication permite máximo 1 botón.";
			if (hasCopyCode) return null;
			if (hasQuickReply || hasUrl || hasPhone) return "Authentication solo permite botones de tipo Copiar Código.";
			return null;
		}

		if (btns.length > 2) return "Marketing/Utility permite máximo 2 botones.";
		if (urlCount > 1) return "No se pueden tener 2 botones de URL.";
		if (phoneCount > 1) return "No se pueden tener 2 botones de teléfono.";
		if (hasUrl && hasPhone) return "No se pueden combinar botón de URL y teléfono.";

		return null;
	};

	const handlerSaved = async () => {
		const buttonError = validateButtons();
		if (buttonError) {
			dispatch(displayNotification({ text: buttonError, isError: true }));
			return;
		}

		const validationObj = {
			title,
			externalFunction,
			channelId,
			body,
			document,
			header,
		};

		const validation = schema.validate(validationObj, { abortEarly: false });
		if (validation.error) {
			const { details } = validation.error;
			let errorsVal = {
				title: "",
				externalFunction: "",
				body: "",
				channelId: "",
				document: "",
				header: "",
			};
			map(details, (item) => {
				errorsVal = { ...errorsVal, [item.context.key]: item.message };
			});
			setErrors(errorsVal);
		} else {
			if (modalOption === "Add") {
				const initialIds = new Set(
					(initialFormData?.buttons || [])
						.map((b) => {
							return b.id;
						})
						.filter(Boolean)
				);
				const newButtons = (filteredItems || [])
					.filter((b) => {
						return !b.id || !initialIds.has(b.id);
					})
					.map(({ id, templateId, ...rest }) => {
						return rest;
					});
				const dataEditor = {
					title: trim(title),
					attachmentType: types,
					attachContactName,
					attachmentUri: document || images[0],
					externalFunction,
					isActive,
					isPromo,
					...(newButtons.length ? { buttons: newButtons } : {}),
					channelId,
					header,
					body,
					bodyExample,
					language,
					category,
					sendToMeta,
				};
				await dispatch(genericAction({ method: "post", route: `templates`, body: dataEditor, onSuccess }));
			} else {
				const normalizeButtons = (arr = []) => {
					return (arr || [])
						.map(({ templateId, createdAt, updatedAt, ...rest }) => {
							return rest;
						})
						.sort((a, b) => {
							return (a.id ?? Infinity) - (b.id ?? Infinity);
						});
				};

				let dataEditor = {};
				const newButtons = map(filteredItems || [], (btn) => {
					return btn.id ? omit(btn, ["templateId"]) : omit(btn, ["id", "templateId"]);
				});
				const prevBtns = normalizeButtons(get(initialFormData, "buttons", []));
				const currBtns = normalizeButtons(filteredItems || []);
				const buttonsChanged = !isEqual(prevBtns, currBtns);
				const prevAfterDeletes = reject(prevBtns || [], (b) => {
					return includes(buttonsD, b.id);
				});
				const deletionsOnly = !isEmpty(buttonsD) && isEqual(prevAfterDeletes, currBtns);

				if (title !== initialFormData.title) dataEditor = { ...dataEditor, title: trim(title) };
				if (types !== initialFormData.attachmentType) dataEditor = { ...dataEditor, attachmentType: types };
				if (attachContactName !== initialFormData.attachContactName) dataEditor = { ...dataEditor, attachContactName };
				if (document !== initialFormData.attachmentUri) dataEditor = { ...dataEditor, attachmentUri: document || null };
				if (images[0] !== initialFormData.attachmentUri) dataEditor = { ...dataEditor, attachmentUri: images[0] || null };
				if (externalFunction !== initialFormData.externalFunction) dataEditor = { ...dataEditor, externalFunction };
				if (isActive !== initialFormData.isActive) dataEditor = { ...dataEditor, isActive };
				if (isPromo !== initialFormData.isPromo) dataEditor = { ...dataEditor, isPromo };
				if ((channelId ?? null) !== (initialFormData?.channelId ?? null)) {
					dataEditor = { ...dataEditor, channelId: channelId ?? null };
				}
				if (!isEmpty(buttonsD)) {
					dataEditor = { ...dataEditor, buttonsD };
				}
				if (buttonsChanged && !deletionsOnly) {
					dataEditor = { ...dataEditor, buttons: newButtons };
				}
				if (header !== initialFormData.header) dataEditor = { ...dataEditor, header };
				if (body !== initialFormData.body) dataEditor = { ...dataEditor, body };
				if (bodyExample !== initialFormData.bodyExample) dataEditor = { ...dataEditor, bodyExample };
				if (language !== initialFormData.language) dataEditor = { ...dataEditor, language };
				if (category !== initialFormData.category) dataEditor = { ...dataEditor, category };

				await dispatch(
					genericAction({
						method: "patch",
						route: `templates/${tableValue.id}`,
						body: dataEditor,
						onSuccess,
					})
				);
			}

			setErrors({
				title: "",
				externalFunction: "",
				channelId: "",
				body: "",
				document: "",
				header: "",
			});
		}
	};

	const validateBeforeMeta = () => {
		const metaErrors = [];

		const buttonError = validateButtons();
		if (buttonError) metaErrors.push(buttonError);

		if (category === "Authentication") {
			if (types && types !== "Text") {
				metaErrors.push("Authentication no permite archivos multimedia (solo texto).");
			}
			const variableRegex = /\{\{(\d+)\}\}/g;
			let match = variableRegex.exec(body);
			while (match !== null) {
				const paramMatch = match[1];
				if (paramMatch.length > 15) {
					metaErrors.push(`La variable {{${paramMatch}}} excede los 15 caracteres permitidos en Authentication.`);
				}
				match = variableRegex.exec(body);
			}
		}

		return metaErrors;
	};

	const handleSendToMeta = async () => {
		const validationErrors = validateBeforeMeta();
		if (validationErrors.length > 0) {
			dispatch(displayNotification({ text: validationErrors[0], isError: true }));
			return;
		}
		setSendingToMeta(true);
		try {
			const response = await dispatch(
				genericAction({
					method: "post",
					route: `templates/${tableValue.id}/resend-meta`,
					withLoading: false,
				})
			);
			if (response && !Array.isArray(response)) {
				setMetaStatusLocal("PENDING");
				dispatch(displayNotification({ text: "Plantilla enviada a Meta exitosamente.", isError: false }));
			}
		} catch (error) {
			dispatch(displayNotification({ text: "Error al enviar la plantilla a Meta.", isError: true }));
		} finally {
			setSendingToMeta(false);
		}
	};

	// modal
	const cancelModal = () => {
		onClose();
	};

	const modalOpen = () => {
		if (modalOption === "Add" && isEmpty(initialFormData)) {
			onClose();
			return;
		}
		const prev = {
			title: initialFormData?.title || "",
			attachmentType: initialFormData?.attachmentType || "",
			attachContactName: !!initialFormData?.attachContactName,
			externalFunction: initialFormData?.externalFunction || "",
			isActive: !!initialFormData?.isActive,
			isPromo: !!initialFormData?.isPromo,
			channelId: initialFormData?.channelId != null ? Number(initialFormData.channelId) : null,
			buttons: initialFormData?.buttons || [],
			header: initialFormData?.header || "",
			body: initialFormData?.body || "",
			bodyExample: initialFormData?.bodyExample || "",
			language: initialFormData?.language || "Spanish",
			category: initialFormData?.category || "Marketing",
		};
		const curr = {
			title: title || "",
			attachmentType: types || "",
			attachContactName: !!attachContactName,
			externalFunction: externalFunction || "",
			isActive: !!isActive,
			isPromo: !!isPromo,
			channelId: channelId != null ? Number(channelId) : null,
			buttons: filteredItems || [],
			header: header || "",
			body: body || "",
			bodyExample: bodyExample || "",
			language: language || "Spanish",
			category: category || "Marketing",
		};

		const unchanged = isEqual(prev, curr);

		if (unchanged) {
			onClose();
		} else {
			setOpen((v) => {
				return !v;
			});
		}
	};

	const handleOpenModal = () => {
		setModalCrupButton("Add");
		setOpenModalAdd(!openModalAdd);
	};

	const isFieldDisabled = (includeInApproved = false) => {
		if (modalOption === "Watch") return true;
		if (isApproved && !includeInApproved) return true;
		return false;
	};

	const footerButtons =
		modalOption === "Edit" && metaStatus !== "Aprobada"
			? [
					<Button
						key="send-meta-btn"
						loading={sendingToMeta}
						disabled={sendingToMeta || (metaStatus !== "Local" && metaStatus !== "Rechazada")}
						onClick={handleSendToMeta}
						className={styles.sendMetaButton}>
						Enviar a Meta
					</Button>,
			  ]
			: [];

	return (
		<IKModal
			title={modalOption === "Add" ? "Agregar Nueva Plantilla" : `Plantilla: ${title || ""} - ${get(company, "name", "")}`}
			id={modalOption !== "Add" ? String(tableValue.id) : ""}
			mode={modalOption}
			setMode={setModalOption}
			size="large"
			fullHeight
			onClose={modalOpen}
			onSuccess={handlerSaved}
			footerButtons={footerButtons}
			hideEditButton={modalOption === "Watch" && metaStatus !== "Local" && metaStatus !== "Rechazada"}
			ignoreContent>
			<div style={{ overflowY: "auto", padding: "1.5rem" }}>
				<div className={styles.noPaddingContainer}>
					<Grid className={styles.fieldset} stackable doubling>
						<Grid.Row columns={2}>
							<Grid.Column width={16} mobile={16} tablet={8} computer={8}>
								<Form.Field>
									<label className={styles.Active}>
										Nombre: <span className={styles.required}>*</span>
									</label>
									<Input
										icon="bullhorn"
										value={title}
										required
										onChange={(e, { value }) => {
											setTitle(value);
										}}
										placeholder="Ej. Bienvenida a clientes"
										className={styles.input}
										fluid
										disabled={isFieldDisabled()}
									/>
									{!isEmpty(errors.title) && (
										<Label basic color="red" className={styles.errorLabel}>
											{errors.title}
										</Label>
									)}
								</Form.Field>
							</Grid.Column>
							<Grid.Column width={16} mobile={16} tablet={8} computer={8}>
								<Form.Field className={styles.divChecks}>
									<div>
										<label className={styles.Active}>Activo</label>
										<Form.Checkbox
											checked={isActive}
											toggle
											label={isActive ? "Si" : "No"}
											onChange={(e, { checked }) => {
												setIsActive(checked);
											}}
											disabled={isFieldDisabled(true)}
										/>
									</div>
									<div className={styles.divIsPromo}>
										<label className={styles.Active}>Es Promo</label>
										<Form.Checkbox
											checked={isPromo}
											toggle
											label={isPromo ? "Si" : "No"}
											onChange={(e, { checked }) => {
												setIsPromo(checked);
											}}
											disabled={isFieldDisabled()}
										/>
									</div>
									<div className={styles.divIsPromo}>
										<label className={styles.Active}>Incluir contacto</label>
										<Form.Checkbox
											checked={attachContactName}
											toggle
											label={attachContactName ? "Si" : "No"}
											onChange={(e, { checked }) => {
												setAttachContactName(checked);
											}}
											disabled={isFieldDisabled()}
										/>
									</div>
								</Form.Field>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row columns={2}>
							<Grid.Column width={16} mobile={16} tablet={8} computer={8}>
								<Form.Field>
									<label className={styles.Active}>
										Plantilla Whatsapp: <span className={styles.required}>*</span>
									</label>
									<Input
										icon="whatsapp"
										required
										value={externalFunction}
										onChange={(e, { value }) => {
											setExternalFunction(value);
										}}
										placeholder="Ej. bienvenida_clientes_01"
										className={styles.input}
										fluid
										disabled={isFieldDisabled()}
									/>
									{!isEmpty(errors.externalFunction) && (
										<Label basic color="red" className={styles.errorLabel}>
											{errors.externalFunction}
										</Label>
									)}
								</Form.Field>
							</Grid.Column>
							<Grid.Column width={16} mobile={16} tablet={8} computer={8}>
								<Form.Field>
									<label className={styles.textBoxColor}>
										Canal: <span className={styles.required}>*</span>
									</label>
									<Dropdown
										value={channelId}
										options={channelOption}
										fluid
										disabled={isFieldDisabled()}
										placeholder="Seleccionar Canal"
										name="types"
										className={styles.input}
										clearable
										onChange={(e, { value }) => {
											setChannelId(value);
										}}
										search
										selection
									/>
									{!isEmpty(errors.channelId) && (
										<Label basic color="red" className={styles.errorLabel}>
											{errors.channelId}
										</Label>
									)}
								</Form.Field>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row columns={2}>
							<Grid.Column width={16} mobile={16} tablet={8} computer={4}>
								<Form.Field>
									<label className={styles.textBoxColor}>Lenguaje:</label>
									<Dropdown
										value={language}
										options={LenguajeOptions}
										onChange={(e, { value }) => {
											return setLanguage(value);
										}}
										selection
										fluid
										search
										placeholder="Seleccionar"
										disabled={isFieldDisabled()}
									/>
								</Form.Field>
							</Grid.Column>
							<Grid.Column width={16} mobile={16} tablet={8} computer={4}>
								<Form.Field>
									<label className={styles.textBoxColor}>Categoría:</label>
									<Dropdown
										value={category}
										options={categoryOptions}
										onChange={(e, { value }) => {
											return setCategory(value);
										}}
										selection
										fluid
										search
										placeholder="Seleccionar"
										disabled={isFieldDisabled()}
									/>
								</Form.Field>
							</Grid.Column>
							<Grid.Column width={2} mobile={16} tablet={6} computer={8}>
								<Form.Field>
									<TextAreaInput
										label="Header:"
										name="header"
										value={header}
										placeholder="Ej. ¡Hola! ¿Cómo estás?"
										onChange={(e) => {
											return setHeader(e.target.value);
										}}
										disabled={isFieldDisabled()}
										error={errors.header}
										minRows={1}
										maxRows={6}
										showCount
										maxLength={60}
									/>
								</Form.Field>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row>
							<Grid.Column width={16}>
								<Form.Field>
									<label className={styles.Active}>
										Body: <span className={styles.required}>*</span>
									</label>
									<TextAreaInput
										name="body"
										value={body}
										placeholder="Ej. Hola {{1}}, tu cita es el {{2}}. Responde SI para confirmar."
										onChange={(e) => {
											return setBody(e.target.value);
										}}
										disabled={isFieldDisabled()}
										error={errors.body}
										minRows={3}
										maxRows={10}
										showCount
										maxLength={1024}
									/>
								</Form.Field>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row>
							<Grid.Column width={16}>
								<Form.Field>
									<Input
										icon="lightbulb outline"
										value={bodyExample}
										onChange={(e, { value }) => {
											return setBodyExample(value);
										}}
										placeholder="Ej. Juan, 15 de agosto"
										className={styles.input}
										fluid
										disabled={isFieldDisabled()}
										label="Ejemplos de parámetros (separados por coma):"
									/>
								</Form.Field>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row>
							<Grid.Column width={16} mobile={16} tablet={8} computer={8}>
								<label className={styles.textBoxColor}>Tipo de Media:</label>
								<Dropdown
									value={types}
									options={typesOptions}
									fluid
									disabled={isFieldDisabled()}
									placeholder="Tipo"
									name="types"
									className={styles.inputDropdown}
									clearable
									onChange={(e, { value }) => {
										setTypes(value);
										setDocument(undefined);
										setImages([]);
										setImagesD([]);
										setErrors((prev) => {
											return { ...prev, document: "" };
										});
									}}
									search
									selection
								/>
							</Grid.Column>
							<Grid.Column width={16} mobile={16} tablet={8} computer={8}>
								<Form.Field>
									{types === "Image" && (
										<>
											<label className={styles.Active}>Cargar imagen</label>
											<FileManager
												images={images}
												setImages={setImages}
												imagesD={imagesD}
												setImagesD={setImagesD}
												disabled={isFieldDisabled()}
												width={3}
												height={3}
											/>
										</>
									)}
									{types === "Document" && (
										<>
											<label className={styles.Active}>Cargar Archivo</label>
											<FileManager
												images={document ? [document] : []}
												setImages={(arr) => {
													return setDocument(arr[0] || "");
												}}
												disabled={isFieldDisabled()}
												type="file"
												accept=".pdf"
												width={3}
												height={3}
											/>
										</>
									)}
									{types === "Video" && (
										<>
											<label className={styles.Active}>Cargar Video</label>
											<FileManager
												images={document ? [document] : []}
												setImages={(arr) => {
													return setDocument(arr[0] || "");
												}}
												disabled={isFieldDisabled()}
												type="video"
												accept=".mp4"
												width={3}
												height={3}
											/>
											{!isEmpty(errors.document) && (
												<Label basic color="red" className={styles.errorLabel}>
													{errors.document}
												</Label>
											)}
										</>
									)}
									{types === "Audio" && (
										<>
											<label className={styles.Active}>Cargar Audio</label>
											<FileManager
												images={document ? [document] : []}
												setImages={(arr) => {
													return setDocument(arr[0] || "");
												}}
												disabled={isFieldDisabled()}
												type="audio"
												accept=".mp3"
												width={6}
												height={6}
											/>
										</>
									)}
								</Form.Field>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row>
							<Grid.Column width={16} mobile={16} tablet={16} computer={16}>
								<fieldset className={styles.fieldsetButtons}>
									<legend className={styles.legendButtons}>BOTONES - {filteredItems.length}</legend>
									<NewTable
										data={filteredItems}
										columns={[
											{
												label: "Acciones",
												action: [
													{
														content: "trash",
														color: "#b43333",
														onClick: "Eraser",
														type: "icon",
														visible: () => {
															return !isApproved;
														},
													},
													{
														content: "edit",
														color: "#3f7ea3",
														onClick: "Edit",
														type: "icon",
														visible: () => {
															return !isApproved && ["Local", "Rechazada"].includes(metaStatus);
														},
													},
												],
												dataPosition: "center",
												width: 1,
												canFilter: false,
												canSort: false,
												addButton: !isApproved && filteredItems.length < 3 ? handleOpenModal : false,
												hidden: modalOption === "Watch" || isApproved,
											},
											{
												label: "ID",
												key: "id",
												format: "string",
												dataPosition: "center",
												width: 1,
											},
											{
												label: "Tipo",
												key: "msgType",
												format: "string",
												headerPosition: "left",
												width: 3,
											},
											{
												label: "Texto",
												key: "text",
												format: "string",
												headerPosition: "left",
												width: 15,
											},
										]}
										defaultOrder={{ key: "id", dir: "asc" }}
										pageRows={7}
										// rowStyle={rowStyle}
										handlerTable={handleButton}
									/>
								</fieldset>
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</div>
			</div>
			{open && (
				<ConfirmModal
					buttonLabel="Salir"
					visible
					header="Confirmar"
					content="Está seguro que desea salir del formulario"
					onConfirm={cancelModal}
					onDismiss={modalOpen}
				/>
			)}

			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar"
					buttonLabel="Eliminar"
					fullContent="¿Está seguro que desea eliminar este botón?"
					focus={itemDelete.text}
					onConfirm={() => {
						deleteButton();
					}}
					onDismiss={() => {
						return setOpenConfirmModal(false);
					}}
				/>
			)}

			{openModalAdd && (
				<ButtonstCrud
					data={filteredItems}
					modalCrud={modalCrudButton}
					onClose={() => {
						setOpenModalAdd(false);
					}}
					setData={setFilteredItems}
					itemSelect={tableValue2}
					templateId={tableValue.id}
					metaStatus={metaStatus}
				/>
			)}
		</IKModal>
	);
};

TemplateCrud.propTypes = {
	tableValue: PropTypes.object,
	onClose: PropTypes.func,
	dispatch: PropTypes.func,
	modalCrud: PropTypes.string,
	refresh: PropTypes.func,
	company: PropTypes.object,
	metaStatus: PropTypes.string,
};

function mapStateToProps({ company }) {
	return {
		company,
	};
}
export default connect(mapStateToProps)(TemplateCrud);
